import { configureStore } from "@reduxjs/toolkit";
import inquiryReducer from "./slices/inquirySlice"; // example slice

export const store = configureStore({
  reducer: {
    inquiry: inquiryReducer,
  },
});
